import { render, staticRenderFns } from "./CredentialEditAuthorizing.vue?vue&type=template&id=55586f04&"
import script from "./CredentialEditAuthorizing.vue?vue&type=script&lang=js&"
export * from "./CredentialEditAuthorizing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports